import { Observable } from 'rxjs';
import { StudentLesson, Lesson } from '../Elearning-Models';
import { IAPIService } from './API-Service/IAPIService';
import { EventEmitter } from '@angular/core';

export abstract class IStudentLessonService{
    abstract getLessons(lessonid: number);
    abstract lessonsEmitter: EventEmitter<StudentLesson[]>;
    abstract emitLessons(lessonid: number);

    abstract getLessonByID(lessonid: number);
    abstract emitLesson(lessonid: number);
    abstract lessonEmitter: EventEmitter<Lesson>;
}

export class StudentLessonService implements IStudentLessonService{

    lessonsEmitter: EventEmitter<StudentLesson[]> = new EventEmitter<StudentLesson[]>();
    lessons: StudentLesson[];

    lessonEmitter: EventEmitter<Lesson> = new EventEmitter<Lesson>();
    lesson: Lesson;

    constructor(private APIService: IAPIService){
    }

    
    getLessons(lessonid: number) {
        this.APIService.GetStudentLessons(lessonid).subscribe( result => {
            this.onLessonsAvailable(result);
        });
    }

    getLessonByID(lessonid: number){
        this.APIService.GetLessonByID(lessonid).subscribe( result => {
            this.onLessonAvailable(result);
        })
    }

    onLessonAvailable(lesson: Lesson){
        this.lesson = lesson;
        this.lessonEmitter.emit(this.lesson);
    }

    onLessonsAvailable(lessons: StudentLesson[]){
        this.lessons = lessons;
        this.lessonsEmitter.emit(this.lessons);
    }

    emitLessons(lessonid: number){
        if(!this.lessons){
            this.getLessons(lessonid);
        }
        else{
            this.onLessonsAvailable(this.lessons);
        }
    }

    emitLesson(lessonid: number){
        if(!this.lesson){
            this.getLessonByID(lessonid);
        }
        else{
            this.onLessonAvailable(this.lesson);
        }
    }
    
}